import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import Auth from '@aws-amplify/auth'
import '@xyflow/react/dist/style.css';  // important to React Flow!!
import './styles/index.css';            // important to React Flow!!


Auth.configure({
    Auth: {
        mandatorySignIn: true,
        region: import.meta.env.VITE_APP_HELPIA_AWS_REGION,
        userPoolId: import.meta.env.VITE_APP_HELPIA_USER_POOL_ID,
        userPoolWebClientId: import.meta.env.VITE_APP_HELPIA_USER_POOL_WEB_CLIENT_ID,
    },
})

if (import.meta.env.VITE_ENV === 'production') {
    Sentry.init({
        dsn: 'https://8d389599b07a97bb27ca407ccaf813ac@o4508618779328512.ingest.us.sentry.io/4508676574281728',
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.browserProfilingIntegration(),
            Sentry.replayIntegration(),
            Sentry.consoleLoggingIntegration({ levels: ['error', 'warn'] }),
            Sentry.browserSessionIntegration(),
            Sentry.httpClientIntegration(),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        // tracePropagationTargets: [/^https:\/\/backend\.cgc\.helpia\.com(\/.*)?$/],
        // Session Replay
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        // Set profilesSampleRate to 1.0 to profile every transaction.
        // Since profilesSampleRate is relative to tracesSampleRate,
        // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
        // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
        // results in 25% of transactions being profiled (0.5*0.5=0.25)
        profilesSampleRate: 1.0,
        _experiments: {
            enableLogs: true,
            beforeSendLog: (log) => {
                if (log.level === 'info') {
                    // Filter out all info logs
                    return null;
                }
                
                return log;
            },
        },
    });
}


ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>,
)
